<li class="slds-tabs_scoped__item {{ isOpen ? 'slds-is-active' : '' }}">
<ng-content></ng-content>
</li>
